import analytics from '../../../analytics/Analytics';

angular.module('gallery').factory('galleryAnalytics', ['$rootScope', function($rootScope) {

    /**
     * event updateMetaInfo is emitted from trackCtrl.
     * And trackCtrl is initialized by trackable directive
     */
    $rootScope.$on('updateMetaInfo', function(event, meta) {
        /**
         * meta.isFirstLoad is set to be true on trackCtrl
         * Don't need to run the following block code on page load.
         * Only run it when users scroll the page
         */
        if (!meta.isFirstLoad) {

            /**
             * analytics.currentArticleIndex is set on onPageChanged
             * in /threethings/factories/storyEvents.service.js
             * @type {number} FsCurrentStory index starts at 1: first article is 1, second article is 2 and so on
             * we need to minus it by 1 since metadataStorage array starts at 0
             */
            var i = FsCurrentStory - 1;
            var pageType = analytics.metadataStorage[i].page_type;

            //check if it is gallery page to enforce tracking only run on gallery page
            if ('gallery' === pageType) {
                sendGallerySlideViewCall(meta, analytics.metadataStorage[i]);
                sendParselyTracking();
            }

        }
    });

    /**
     * @desc send analytic meta data to utag on every image slide
     * @param metatag Meta tags in the DOM
     * @param analyticsMeta Analytics meta object
     */
    function sendGallerySlideViewCall(metatag, analyticsMeta) {
        var utagData = {
            page_type: 'gallery',
            page_name: analyticsMeta.page_name,
            page_attribute: 'gallery_slide_list',
            gallery_name: metatag.headline,
            category: analyticsMeta.category,
            slide_num: metatag.slideNumber + 1,
            story_position: FsCurrentStory,
            author: analyticsMeta.author,
            story_title: analyticsMeta.story_title
        };
        analytics.utagView(utagData);
    }

    function sendParselyTracking() {
        if (typeof PARSELY !== 'undefined' && typeof PARSELY.beacon === 'object' && typeof PARSELY.beacon.trackPageView === 'function') {
            PARSELY.beacon.trackPageView({
                url: location.href, // URL to be tracked
                urlref: location.href,
                js: 1 // flag indicating that this is a dynamic event, keep it "1"
            });
        }
    }
    return {};
}]);


// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/analytics/analyticsService.js